module.exports = __webpack_public_path__ + "static/ncvm-shop-tag-bfeade44c73f94955ec8323bfc0fba3d.png";